(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const init = root => {
    root.querySelectorAll('[data-paw-carousel]').forEach(carousel => {
      if (carousel.dataset.pawReady) return;
      carousel.dataset.pawReady = 'true';
      const track = carousel.querySelector('[data-paw-track]');
      if (!track) return;
      const originals = [...track.children];
      const dots = [...carousel.querySelectorAll('[data-paw-dot]')];
      const isGifts = carousel.hasAttribute('data-paw-mobile-only');
      let active = 0;
      let timer;
      let resizing, lastWidth = 0, wasMobile;
      if (!isGifts && originals.length > 1) {
        const leading = originals.at(-1).cloneNode(true);
        const trailing = originals[0].cloneNode(true);
        for (const node of [leading, trailing]) {
          node.dataset.pawClone = 'true';
          node.setAttribute('aria-hidden', 'true');
          node.querySelectorAll('video').forEach(video => { video.tabIndex = -1; });
        }
        track.prepend(leading);
        track.append(trailing);
      }
      const stepWidth = () => originals[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
      const updateDots = () => dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      const pauseVideos = () => track.querySelectorAll('video').forEach(video => video.pause());
      const goTo = (index, animate = true) => {
        clearTimeout(timer);
        const count = originals.length;
        if (!count) return;
        active = (index + count) % count;
        updateDots();
        pauseVideos();
        if (!mobile.matches && isGifts) return;
        if (!mobile.matches && !isGifts) {
          const ordered = originals.slice(active).concat(originals.slice(0, active));
          const clones = [...track.querySelectorAll('[data-paw-clone]')];
          track.replaceChildren(...ordered, ...clones);
          track.scrollLeft = 0;
          return;
        }
        const position = (active + (isGifts ? 0 : 1)) * stepWidth();
        track.scrollTo({ left: position, behavior: animate && !reducedMotion.matches ? 'smooth' : 'auto' });
      };
      carousel.querySelectorAll('[data-paw-step]').forEach(button => button.addEventListener('click', () => goTo(active + Number(button.dataset.pawStep))));
      dots.forEach(dot => dot.addEventListener('click', () => goTo(Number(dot.dataset.pawDot))));
      track.addEventListener('scroll', () => {
        clearTimeout(timer);
        if (!mobile.matches || resizing) return;
        timer = setTimeout(() => {
          if (!mobile.matches || resizing) return;
          if (track.clientWidth !== lastWidth || mobile.matches !== wasMobile) { resize(); return; }
          const index = Math.round(track.scrollLeft / stepWidth()) - (isGifts ? 0 : 1);
          active = (index + originals.length) % originals.length;
          updateDots();
          if (!isGifts && (index < 0 || index >= originals.length)) goTo(active, false);
        }, 100);
      }, { passive: true });
      const resize = () => {
        clearTimeout(timer);
        if (track.clientWidth === lastWidth && mobile.matches === wasMobile) return;
        cancelAnimationFrame(resizing);
        resizing = requestAnimationFrame(() => {
          if (mobile.matches && !isGifts) {
            const clones = [...track.querySelectorAll('[data-paw-clone]')];
            track.replaceChildren(clones[0], ...originals, clones[1]);
          }
          goTo(active, false);
          lastWidth = track.clientWidth;
          wasMobile = mobile.matches;
          resizing = undefined;
        });
      };
      mobile.addEventListener('change', resize);
      window.addEventListener('resize', resize, { passive: true });
      requestAnimationFrame(resize);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
